<script setup lang="ts">
const emit = defineEmits<{
  (e: 'click'): void;
}>();

const closeButtonRef = ref<HTMLElement | null>(null);

const setFocus = () => {
  closeButtonRef.value?.focus();
};

defineExpose<{
  setFocus: () => void;
}>({
  setFocus,
});
</script>

<template>
  <button
    class="close-button"
    ref="closeButtonRef"
    @click="$emit('click')"
    type="button"
    :aria-label="$t('closeButton')"
  >
    <span class="text-2xs _hidden-vs">{{ $t('closeButton') }}</span>
    <svg
      class="icon"
      role="img"
      aria-hidden="true"
      width="24"
      height="20"
      viewBox="0 0 24 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="3.01172"
        y="17.8008"
        width="24"
        height="2"
        transform="rotate(-45 3.01172 17.8008)"
      />
      <rect
        x="4.01172"
        y="0.800781"
        width="24"
        height="2"
        transform="rotate(45 4.01172 0.800781)"
      />
    </svg>
  </button>
</template>

<style scoped lang="scss">
.close-button {
  all: unset;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  gap: 1rem;
  color: var(--base-color-foreground);

  // Expand clickable area
  &::before {
    content: '';
    position: absolute;
    inset: -1rem;
    z-index: -1;
    border-radius: 0.25rem;
  }

  &:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }
}

.close-button > .icon {
  fill: var(--base-color-foreground);
}
</style>
